import { API_URL } from "./Config";
import { formatDate } from "./DateUtils";
import { IDetailsResponse } from "./IDetailsResponse";
import { GetLicenseDetailsAsync, ILicenceDetails } from "./LicenceDetails";

export interface IThirdPartyCorrespondenceDetails extends IDetailsResponse {
  thirdpartycorrespondenceid: string;
  type: string;
  reference: string;
  receivedfrom: string;
  subject: string;
  status: string;
  dateoriginalcorrespondencereceived: string;
  dateoforiginalcorrespondence: string;
  inspectorsupdate: string;
  correspondencetype: string;
  licenceid: string;
  licenceprofileid: string;
  licenceDetails?: ILicenceDetails;
}

export async function GetThirdPartyCorrespondenceDetailsAsync(
  thirdPartyCorrespondenceId: string
): Promise<IThirdPartyCorrespondenceDetails> {
  var url = `${API_URL}/MeetingCorrespondence/thirdpartycorrespondencebyid?thirdpartycorrespondence_id=${thirdPartyCorrespondenceId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/3rdparty-correspondence`;
  }

  var response = await fetch(url);
  var body = <IThirdPartyCorrespondenceDetails>await response.json();

  body.licenceDetails = await GetLicenseDetailsAsync(body.licenceid);

  return <IThirdPartyCorrespondenceDetails>{
    response: response,
    thirdpartycorrespondenceid: body.thirdpartycorrespondenceid,
    type: body.type,
    reference: body.reference,
    receivedfrom: body.receivedfrom,
    subject: body.subject,
    status: body.status,
    dateoriginalcorrespondencereceived: formatDate(
      body.dateoriginalcorrespondencereceived
    ),
    dateoforiginalcorrespondence: formatDate(body.dateoforiginalcorrespondence),
    inspectorsupdate: body.inspectorsupdate,
    correspondencetype: body.correspondencetype,
    licenceid: body.licenceid,
    licenceprofileid: body.licenceprofileid,
    licenceDetails: body.licenceDetails,
  };
}
